export const API = {
  group: {
    addVehicleGroup: '/vas/vehicleRepositories/addVehicleGroup.json', // 新增组
    updateGroup: '/vas/vehicleRepositories/updateVehicleGroup.json', // 更新组
    queryVehicleGroup: '/vas/vehicleRepositories/queryVehicleGroup.json',
    deleteVehicleGroup: '/vas/vehicleRepositories/deleteVehicleGroup.json'
  },
  bw: {
    'queryBwPlat':'/vas/vehicleRepositories/queryBwPlat.json',
    'updateBwlist':'/vas/vehicleRepositories/updateBwlist.json',
    'addBwlist':'/vas/vehicleRepositories/addBwlist.json',
    'deleteBwlist':'/vas/vehicleRepositories/deleteBwlist.json'
  },
  common:{
    // 上传图片
    'batchFileload': '/common/file/batchFileload.json'
  }
}
